import * as React from 'react'
import {Link} from 'gatsby'

// styles
const pageStyles = {
  color: '#fff',
  padding: '96px'
}
const headingStyles = {
  marginTop: 0,
  marginBottom: 64,
  maxWidth: 320
}

const paragraphStyles = {
  marginBottom: 48
}

// markup
const NotFoundPage = () => {
  return (
    <main style={pageStyles}>
      <title>Not found</title>
      <h1 style={headingStyles}>Page introuvable</h1>
      <p style={paragraphStyles}>
        <span role="img" aria-label="Pensive emoji">
          😔
        </span>
        <br />
        <br />
        <br />
        <Link to="/">Retour à l'accueil</Link>.
      </p>
    </main>
  )
}

export default NotFoundPage
